import apiClient from './api-client';

// API Path Constants
const API_BASE = '/translation';
const API_PATHS = {
    BASE: API_BASE,
} as const;

interface TranslationRequest {
  targetLanguage: string;
  en: {
    [key: string]: string;
  };
}

interface TranslationResponse {
  [language: string]: {
    [key: string]: string;
  };
}

export const translationService = {
  translate: async (text: string, targetLanguage: string): Promise<string> => {
    const request: TranslationRequest = {
      targetLanguage,
      en: {
        labelText: text
      }
    };

    const response = await apiClient.post<TranslationResponse>(API_PATHS.BASE, request);
    return response[targetLanguage].labelText;
  },

  // Batch translation for multiple fields (name, description, options)
  translateBatch: async (fields: { [key: string]: string }, targetLanguage: string): Promise<{ [key: string]: string }> => {
    const request: TranslationRequest = {
      targetLanguage,
      en: fields
    };
    const response = await apiClient.post<TranslationResponse>(API_PATHS.BASE, request);
    return response[targetLanguage];
  }
}; 